export const CASPER_LOCAL_TRANSCRIPT_MAX_AGE_MS = 8 * 60 * 60 * 1000;

export function messageHasWorkflowContext(message) {
  return Boolean(
    message?.metadata?.workflow_plan
      || message?.metadata?.workflow_run
      || message?.metadata?.workflow_status
      || message?.metadata?.confirmation_required,
  );
}

export function shouldPersistCasperLocalTranscript(messages = []) {
  if (!Array.isArray(messages) || messages.length === 0) return false;
  return messages.some((message) => {
    if (!message || typeof message !== "object") return false;
    if (messageHasWorkflowContext(message)) return true;
    if (message.metadata?.execution_preview) return true;
    if (message.metadata?.kind === "onboarding_chat") return true;
    if (["preview", "pending", "streaming", "paused"].includes(String(message.status || "").toLowerCase())) return true;
    return String(message.id || "").startsWith("local-")
      && message.kind !== "status"
      && ["user", "assistant"].includes(message.role);
  });
}

export function hasRestorableCasperLocalTranscript(
  transcript,
  {
    activeSessionId = null,
    appBootId = null,
    nowMs = Date.now(),
    maxAgeMs = CASPER_LOCAL_TRANSCRIPT_MAX_AGE_MS,
  } = {},
) {
  if (!transcript || !Array.isArray(transcript.messages) || transcript.messages.length === 0) {
    return false;
  }
  if (transcript.session_id) {
    return Boolean(activeSessionId) && String(transcript.session_id) === String(activeSessionId);
  }
  if (!shouldPersistCasperLocalTranscript(transcript.messages)) {
    return false;
  }
  if (!transcript.workflow_run && appBootId && transcript.app_boot_id !== appBootId) {
    return false;
  }
  const updatedAt = Date.parse(transcript.updated_at || "");
  if (!Number.isFinite(updatedAt)) return false;
  return nowMs - updatedAt <= maxAgeMs;
}
